/* eslint-disable no-param-reassign */
const sliceStringAndAddDots = (str = '', maxLength = 0) => {
  if (/^ *$/.test(str)) {
    str = '';
  }
  return str.length > maxLength ? str.slice(0, maxLength).concat('...') : str;
};
export default sliceStringAndAddDots;
